import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isDomainInternalSaga } from '../../Hooks/actionCreators';

/**
 * DomainWhitelistStatus
 * @description Checks if the current pageUrl is whitelisted by performing a call to the isDomainInternal API, this is used elsewhere to determine if we can expose data.
 * @returns null
 */
const DomainWhitelistStatus = () => {
  const { pageUrl } = useSelector((store) => store.formConfig);
  const dispatch = useDispatch();

  useEffect(() => {
    if (pageUrl) {
      /**
       * Get when pageUrl is received from the formLoader send it to the isDomainInternalSaga and backend, which will strip the subdomains and check if it is on the internal domain whitelist
       */
      dispatch(isDomainInternalSaga({ domain: pageUrl }));
    }
  }, [pageUrl]);

  return null;
};

export default DomainWhitelistStatus;
